"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diveMulti_syncWorld = void 0;
var diveSaver_all_sidecar_1 = require("@dive/saver/diveSaver_all-sidecar");
var diveMessage_loadState_sidecar_1 = require("@voyage/multi/diveMessage_loadState-sidecar");
var diveMessage_simulationSync_sidecar_1 = require("@voyage/multi/diveMessage_simulationSync-sidecar");
function diveMulti_syncWorld() {
    console.log('diveMulti_syncWorld', 'syncing world');
    diveMessage_simulationSync_sidecar_1.diveMessage_simulationSync.send(false);
    diveMessage_loadState_sidecar_1.diveMessage_loadState.sendMessageToAll({
        state: diveSaver_all_sidecar_1.diveSaver_all.write(),
    });
    diveMessage_simulationSync_sidecar_1.diveMessage_simulationSync.send(true);
    // // Pause (TODO: move to host command?)
    // diveMessage_simulationSync.send(false)
    // // Pass our saved data to everyone
    // // TODO: compress
    // diveMessage_loadState.sendMessageToAll({
    //   state: diveSaver_all.write(),
    // })
    // // Unpause (TODO: move to host command?)
    // diveMessage_simulationSync.send(true)
    // // TODO: send to all hosts this new info
    // // voyageMessageHostCommand.sendMessageAndImmediatelyExecute({
    // //   command: EHostCommand.LoadScenario,
    // // })
}
exports.diveMulti_syncWorld = diveMulti_syncWorld;
